import { useTranslation } from '@edreamsodigeo/frontend-core';

import useUserSegment from '~clientState/queries/useUserSegment/useUserSegment';

export type debugSegmentType = '1' | '2' | '3' | '4' | '5' | '6' | '7';

export type Variables = Parameters<ReturnType<typeof useTranslation>['t']>[1];

const useTranslateWithSegment = (debugSegment?: debugSegmentType) => {
  const { t } = useTranslation();
  const isEnabledAdaptiveMessaging = t('isEnabledAdaptiveMessaging') === '1';
  const { data } = useUserSegment(!isEnabledAdaptiveMessaging);
  const segmentNumber = data?.segment;
  const translateWithSegment = (
    baseKeyName: string,
    variables?: Variables
  ): { value: string; key: string } => {
    let value = t(baseKeyName, variables);
    let key = baseKeyName;
    if ((isEnabledAdaptiveMessaging && segmentNumber) || debugSegment) {
      const segmentSuffix = `_S${debugSegment || segmentNumber}`;
      const segmentedLabel = t(baseKeyName + segmentSuffix, variables);
      const segmentedKey = baseKeyName + segmentSuffix;
      value = segmentedLabel ? segmentedLabel : value;
      key = segmentedLabel ? segmentedKey : key;
    }
    return { value, key };
  };
  return { translateWithSegment };
};

export default useTranslateWithSegment;
